import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import {
  getBulkDropdownData,
  getDropdownData,
  getOtherRefSearchDropdown,
} from "../../../api/keyvalue";
import LoadingSpinner from "../../LoadingSpinner";
import Input from "../../input/Input";
import { FORMS, MODULES } from "../../../const";
import Dropdown from "../../input/Dropdown";
import InfoList from "../../InfoList";
import { formatFromJsonDate } from "../../../dateConfig";
import { User } from "react-feather";
import SearchDropdown from "../../input/SearchDropdown";
import { getBehalfOf } from "../../../api/systemUserApi";

const FORM = FORMS.CALL_CENTER_SHIFT_GROUP.SHIFT_STK.form;
const ShiftGroupUsers = forwardRef(
  ({ errors, dropdown, isLoading, currentValues, editMode }, ref) => {
    //dropdown
    const [activeOptions, setActiveOptions] = useState([]);
    const [statusOptions, setStatusOptions] = useState([]);
    const [yesNoOptions, setYesNoOptions] = useState([]);

    //bool
    const [searchFieldReset, setSearchFieldReset] = useState(false);
    const [fieldReset, setFieldReset] = useState(false);

    const [shiftGroupUserData, setShiftGroupUserData] = useState(
      editMode
        ? {
            ...currentValues,
          }
        : {
            sguCode: "",
            sguReferance: "",
            sguCompany: "",
            sguGroup: "",
            sguUserName: [],
            sguDescription: "",
            sguStatus: 2,
            sguActive: 1,
            sguUserNameObj: null,
          }
    );

    useEffect(() => {
      (async () => {
        if (editMode) {
          const formattedOutput =
            currentValues?.shiftGroupUsersDropdownResponse.reduce(
              (acc, item) => {
                acc[item.id] = item.text;
                return acc;
              },
              {}
            );

          setShiftGroupUserData((prevState) => ({
            ...prevState,
            sguUserName: formattedOutput,
            sguDescription: currentValues?.sguDescription,
          }));
        }
      })();
    }, [editMode, currentValues]);

    useEffect(() => {
      (async () => {
        //new

        const {
          status,
          active,
          yesno: yesnoOpt,
        } = await getBulkDropdownData([
          { key: "status" },
          { key: "active" },
          { key: "yesno" },
        ]);

        setActiveOptions(active);
        setStatusOptions(status);
        setYesNoOptions(yesnoOpt);
      })();
    }, []);

    const [currentErrors, setCurrentErrors] = useState({});
    useEffect(() => {
      setCurrentErrors(errors);
    }, [errors]);

    useImperativeHandle(ref, () => ({
      getData: () => shiftGroupUserData,

      resetForm: () => {
        setShiftGroupUserData({
          sguCode: "",
          sguReferance: "",
          sguCompany: "",
          sguGroup: "",
          sguUserName: [],
          sguDescription: "",
          sguStatus: 2,
          sguActive: 1,
          sguUserNameObj: null,
        });
        setSearchFieldReset(true);
        setCurrentErrors({});
      },
    }));
    return (
      <>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <form
            className="ui form"
            style={{ overflowY: "auto", height: "75vh" }}
          >
            <div className="ui segment">
              <h4 className="ui dividing header">Shift Group</h4>
              <div className="two fields">
                <Input
                  label="User Code"
                  error={currentErrors.sguCode}
                  module={MODULES.Master}
                  form={FORM}
                  field="shg_code"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { sguCode: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="shgCode"
                  value={shiftGroupUserData.sguCode}
                  onChange={(e) => {
                    setShiftGroupUserData((prevState) => ({
                      ...prevState,
                      sguCode: e.target.value,
                    }));
                  }}
                  disabled={true}
                />
              </div>
              <div className="two fields">
                <SearchDropdown
                  required={true}
                  label="User"
                  error={currentErrors.sguUserName}
                  module={MODULES.Master}
                  form={FORM}
                  // field="shg_stakeholder"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { sguUserName: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="User"
                  returnFullObject={true}
                  multiple={true}
                  reset={fieldReset}
                  setReset={setFieldReset}
                  clearable={true}
                  multiValueRemoveHandler={(key) => {
                    setShiftGroupUserData((prevState) => {
                      const { [key]: _, ...rest } = prevState.sguUserName;
                      return { ...prevState, sguUserName: rest };
                    });
                  }}
                  onResultSelect={(data) => {
                    setShiftGroupUserData((prevState) => ({
                      ...prevState,
                      sguUserName: {
                        ...prevState.sguUserName,
                        [data.key]: data.title,
                      },
                    }));
                  }}
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "shift_users",
                    value: "",
                  }}
                  fieldInfo={{
                    tableName: "authentication.user",
                    primaryKey: "user_seq",
                    fieldName: "username",
                    id: shiftGroupUserData.sguUserName,
                  }}
                  field="req_behalf_of"
                  multiValueTwoWayBinding={true}
                  multiValues={shiftGroupUserData.sguUserName}
                />
              </div>
              <div className="two fields">
                <Input
                  label="Description"
                  error={currentErrors.sguDescription}
                  module={MODULES.Master}
                  form={FORM}
                  field="shg_description"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { sguDescription: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Description"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                  value={shiftGroupUserData.sguDescription}
                  onChange={(e) => {
                    setShiftGroupUserData((prevState) => ({
                      ...prevState,
                      sguDescription: e.target.value,
                    }));
                  }}
                />
              </div>
              <div className="two fields">
                <Dropdown
                  required={true}
                  label="Status"
                  error={currentErrors.sguStatus}
                  module={MODULES.Master}
                  form={FORM}
                  field="shg_status"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { sguStatus: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Status"
                  options={statusOptions}
                  value={shiftGroupUserData.sguStatus}
                  style={{ height: "20px" }}
                  onChange={(e, data) => {
                    setShiftGroupUserData((prevState) => ({
                      ...prevState,
                      sguStatus: data.value,
                    }));
                  }}
                />

                <Dropdown
                  required={true}
                  label="Active"
                  error={currentErrors.sguActive}
                  module={MODULES.Master}
                  form={FORM}
                  field="shg_active"
                  // authenticated={true}
                  needDeletePermission={true}
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { sguActive: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Active"
                  options={activeOptions}
                  value={shiftGroupUserData.sguActive}
                  style={{ height: "20px" }}
                  onChange={(e, data) => {
                    setShiftGroupUserData((prevState) => ({
                      ...prevState,
                      sguActive: data.value,
                    }));
                  }}
                />
              </div>
            </div>
            {editMode && (
              <InfoList
                title="User Information"
                content={[
                  {
                    title: "Created By",
                    value: shiftGroupUserData.createdBy
                      ? shiftGroupUserData.createdBy
                      : "N/A",
                  },
                  {
                    title: "Created Date",
                    value: shiftGroupUserData.createdDate
                      ? formatFromJsonDate(shiftGroupUserData.createdDate)
                      : "N/A",
                  },
                  {
                    title: "Last Modified By",
                    value: shiftGroupUserData.lastModifiedBy
                      ? shiftGroupUserData.lastModifiedBy
                      : "N/A",
                  },
                  {
                    title: "Last Modified Date",
                    value: shiftGroupUserData.lastModifiedDate
                      ? formatFromJsonDate(shiftGroupUserData.lastModifiedDate)
                      : "N/A",
                  },
                ]}
                Icon={User}
              />
            )}
          </form>
        )}
      </>
    );
  }
);
export default ShiftGroupUsers;
